/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import { Component } from '@angular/core';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { ISaleDocument, SALE_TTL_ES } from '../sales.interface';
import { SaleDocumentService } from '../sales.service';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-sale-document',
  templateUrl: './sale-document.component.html',
  styleUrls: ['./sale-document.component.css']
})
export class SaleDocumentComponent extends TableActionsTemplate {
  settingsAmiHead: IAmiHead = {
    title: SALE_TTL_ES,
    addressImg: 'reports'
  };

  constructor(private serviceBase: SaleDocumentService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Reporte de ventas',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Punto Venta', field: 'pointSaleCode' },
        { header: 'Cliente', field: 'clientName' },
        { header: 'DNI / RUC', field: 'clientNumberDocument' },
        { header: 'N° Documento', field: 'numberDocument' },
        { header: 'Comprobante', field: 'typeVoucher' },
        {
          header: 'Tipo Pago',
          field: 'methodPayment',
          tag: 'tagPaymentMethod'
        },
        { header: 'Producto', field: 'producto' },
        { header: 'Cantidad', field: 'cantidad' },
        { header: 'Precio', field: 'precio', pipe: 'Currency' },
        { header: 'Lote', field: 'lote' },
        { header: 'Base imponible', field: 'base', pipe: 'Currency' },
        { header: 'IGV', field: 'igv', pipe: 'Currency' },
        { header: 'Monto', field: 'amount', pipe: 'Currency' },
        { header: 'Ganancia', field: 'profitMargin' },
        {
          header: 'Fecha Creación',
          field: 'sortDate',
          exportField: 'sortDatePeru',
          pipe: 'Date'
        },
        // { header: 'Hora', field: 'hour' },
        { header: 'Vendedor', field: 'userUsername' },
        { header: 'Estado', field: 'statusSale', tag: 'tagStatus' }
      ],
      exportData: true,
      filterColumns: true
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((response: any[]) => {
        const data: ISaleDocument[] = response.map((item) => {
          const fechaParts = item.fechaCompra ? item.fechaCompra.split(' ') : ['', ''];
          const dateParts = fechaParts[0].split('-');
          const sortDate =
            dateParts.length === 3
              ? this.parseUtcDateTime(
                  dateParts[2],
                  dateParts[1],
                  dateParts[0],
                  fechaParts[1] || '00:00:00'
                )
              : new Date();

          return {
            branchStoreName: item.name,
            pointSaleCode: item.pointSaleCode,
            clientName: item.cliente,
            clientNumberDocument: item.clientNumberDocument,
            numberDocument: item.documento,
            typeVoucher: item.comprobante,
            methodPayment: item.tipoPago,
            producto: item.producto,
            cantidad: item.cantidad,
            precio: Number(item.precio),
            lote: item.lote,
            base: Number(item.base),
            igv: Number(item.igv),
            amount: Number(item.monto),
            profitMargin: item.profitMargin,
            sortDate,
            sortDatePeru: this.formatDateTimePeru(sortDate),
            hour: fechaParts[1] || '',
            expAt: item.expAt,
            userUsername: item.userUsername,
            statusSale: item.statusSale,
            tagStatusColor: getTagColor(item.statusSale),
            tagPaymentMethodColor: getTagColor(item.tipoPago),
            id: item.id
          } as ISaleDocument;
        });
        this.table.data = data;
      });
  }

  private parseUtcDateTime(
    year: string,
    month: string,
    day: string,
    time: string
  ): Date {
    const [hours = '00', minutes = '00', seconds = '00'] = time.split(':');
    return new Date(
      Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours),
        Number(minutes),
        Number(seconds)
      )
    );
  }

  private formatDateTimePeru(date: Date): string {
    return new Intl.DateTimeFormat('es-PE', {
      timeZone: 'America/Lima',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
